import PeopleIconPath from "@ingka/ssr-icon/paths/people";

export default PeopleIconPath;
